var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CmsPage',{scopedSlots:_vm._u([{key:"after-content",fn:function(){return [_c('a',{staticClass:"sf-button color-secondary",attrs:{"id":"setCookie","href":"javascript:openAxeptioCookies()"}},[_vm._v("Je modifie mes choix en matière de cookies ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }